module.exports = __webpack_public_path__ + "static/media/brake-fluid-exchange-red.ab9bab87.svg";